/**
 * Resolve with the analytics global once the deferred tracker script has
 * run, or null if it never arrives within the timeout (script blocked, or
 * HUGINN_ID unset). The `typeof` test is what avoids the "umami is not
 * defined" ReferenceError a bare reference throws before the script loads.
 */
const whenReady = (timeoutMs = 5000): Promise<typeof umami | null> =>
  new Promise((resolve) => {
    if (typeof umami !== "undefined") {
      resolve(umami)

      return
    }
    const startedAt = Date.now()
    const poll = setInterval(() => {
      if (typeof umami !== "undefined") {
        clearInterval(poll)
        resolve(umami)
      } else if (Date.now() - startedAt >= timeoutMs) {
        clearInterval(poll)
        resolve(null)
      }
    }, 100)
  })

export default async (eventName: string, payload?: Record<string, unknown>) => {
  // Never track during SSR — there is no tracker and polling would hang
  if (typeof window === "undefined") {
    return
  }
  const tracker = await whenReady()
  // Tracking is best-effort: drop the event if analytics never loaded
  if (!tracker) {
    return
  }
  try {
    await tracker.track(eventName, payload)
  } catch (error) {
    console.error("Huginn:", error)
  }
}
